import { Component, OnInit } from "@angular/core";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { WtfConfigService } from "../../../services/core/config.service";
import { TranslateService } from "@ngx-translate/core";
import { ObservableDataService } from "../../../services/core/observable-data.service";
import { FileService } from "../../../services/shared/file.service";
import { SafeUrl } from "@angular/platform-browser/";
import { AuthenticationService } from "../../../services/security/authentication.service";
import { SecurityMapper } from "../../../utils/mappers/security/security.mapper";
import { StateService } from "../../../services/state/state.service";

@Component({
    selector: "wtf-toolbar",
    templateUrl: "./toolbar.component.html",
    styleUrls: ["./toolbar.component.scss"],
    providers: [AuthenticationService, SecurityMapper],
})
export class WtfToolbarComponent implements OnInit {
    userStatusOptions: any[];
    languages: any;
    selectedLanguage: any;
    showLoadingBar: boolean;
    horizontalNav: boolean;
    avatarUrl: SafeUrl = "";
    ods: ObservableDataService;
    fullName: string;
    companyId: number;
    lang: any;

    constructor(
        private router: Router,
        private wtfConfig: WtfConfigService,
        private translate: TranslateService,
        private _ods: ObservableDataService,
        private stateService: StateService,
        private fs: FileService,
        private authService: AuthenticationService
    ) {
        this.ods = _ods;

        this.userStatusOptions = [
            {
                title: "Online",
                icon: "icon-checkbox-marked-circle",
                color: "#4CAF50",
            },
            {
                title: "Away",
                icon: "icon-clock",
                color: "#FFC107",
            },
            {
                title: "Do not Disturb",
                icon: "icon-minus-circle",
                color: "#F44336",
            },
            {
                title: "Invisible",
                icon: "icon-checkbox-blank-circle-outline",
                color: "#BDBDBD",
            },
            {
                title: "Offline",
                icon: "icon-checkbox-blank-circle-outline",
                color: "#616161",
            },
        ];

        router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.showLoadingBar = true;
            }
            if (event instanceof NavigationEnd) {
                this.showLoadingBar = false;
            }
        });

        this.wtfConfig.onSettingsChanged.subscribe((settings) => {
            this.horizontalNav = settings.layout.navigation === "top";
        });

        this.ods.loggedUser.subscribe((res) => {
            this.companyId = res.companyId;
            this.fullName = res.fullName;
        });
    }

    get showToolbar() {
        return this.stateService.showToolbar;
    }

    search(value) {
        // Do your search here...
    }

    ngOnInit() {
        this.lang = localStorage.getItem("language") || "en";
    }

    logout() {
        this.authService.logout();
        this.router.navigateByUrl("/login");
    }

    changePassword() {
        this.router.navigateByUrl("/change-password");
    }

    myCompany() {
        this.router.navigateByUrl("/login");
        this.router.navigate(["admon", "company", this.companyId, "edit"]);
    }

    changeLanguage(lang) {
        localStorage.setItem("language", lang);
        window.location.reload();
    }
}
